module.exports = __webpack_public_path__ + "img/page-camera.90e1c5fc.png";